import ColumnPromoStatusToko from 'View/stock-promo/component/columnPromoStatusToko';
import ColumnPricePromo from 'View/stock-promo/component/columnPricePromo';
import ColumnProductPromo from 'View/stock-promo/component/columnProductPromo';
import ColumnBarcodePromo from 'View/stock-promo/component/columnBarcodePromo';
import ColumnStockPromo from 'View/stock-promo/component/columnStockPromo';
import { tablePromoText } from 'Const/stock-promo/view';

const tablePromoList = ({ t }) => {
  return [
    {
      name: t('columnTablePromo.promoStatusStore'),
      key: 'name',
      width: 250,
      position: 'left',
      component: ({ value, values }) => <ColumnPromoStatusToko value={value} values={values} />,
    },
    {
      name: t('columnTablePromo.barcode'),
      key: 'promotionProducts',
      position: 'left',
      width: 120,
      component: ({ value }) => {
        return <ColumnBarcodePromo value={value} />;
      },
    },
    {
      name: t('columnTablePromo.productName'),
      key: 'promotionProducts',
      position: 'left',
      width: 350,
      component: ({ value, values }) => {
        return <ColumnProductPromo value={value} values={values} />;
      },
    },
    {
      name: t('columnTablePromo.price'),
      key: 'promotionProducts',
      position: 'left',
      width: 260,
      component: ({ value }) => {
        return <ColumnPricePromo value={value} />;
      },
    },
    {
      name: t('columnTablePromo.stockLeft'),
      labelInfo: t('columnTablePromo.'),
      key: 'promotionProducts',
      position: 'left',
      width: 140,
      component: ({ value }) => {
        return <ColumnStockPromo value={value} />;
      },
    },
    {
      name: t('columnTablePromo.allocationStock'),
      labelInfo: tablePromoText.tooltipAllocationStock,
      key: 'promotionProducts',
      width: 140,
      position: 'left',
      component: ({ value }) => {
        return <ColumnStockPromo value={value} />;
      },
    },
  ];
};

export default tablePromoList;
